import styled from 'styled-components';
import PropTypes from 'prop-types';
import React from 'react';
import { PropTypesMeta } from '@zedoc/react-questionnaire';
import FormItem from './FormItem';
import Input from './Input';

const StyledFormItem = styled(FormItem)`
  width: 100%;
  margin-bottom: 0;
  .ant-form-item-children {
    position: static;
    overflow: hidden;
  }
`;

const FormFieldUnsupported = ({
  meta: { error, touched },
  required,
  questionType,
}) => (
  <StyledFormItem
    required={required}
    validateStatus={
      error ? (touched && 'error') || '' : (required && 'success') || ''
    }
    help={touched ? error : ''}
  >
    <Input placeholder={`[unsupported question: ${questionType}]`} disabled />
  </StyledFormItem>
);

FormFieldUnsupported.propTypes = {
  meta: PropTypesMeta.isRequired,
  questionType: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

FormFieldUnsupported.defaultProps = {
  required: false,
};

export default FormFieldUnsupported;
